<template>
  <section class="max-w-content-container mx-auto pb-10">
    <div class="xl:bg-grey-100 rounded-lg xl:px-11 xl:py-14">
      <div
        class="flex flex-col items-center justify-between gap-x-14 xl:flex-row"
      >
        <div class="xl:w-3/4">
          <h2 class="border-p-500 border-l-4 pl-2 text-lg font-bold lg:text-xl">
            Benchmark Global LCAs
          </h2>
          <div class="mt-6 flex flex-col gap-4 text-sm md:text-base xl:mt-6">
            <span>
              Each Global LCA provides a <strong>detailed analysis</strong> on
              the <strong>environmental impacts</strong> of the dominant
              processing routes at present that demonstrates “average" LCA
              results for each mineral, allowing stakeholders to deepen their
              <strong>knowledge on environmental hotspots</strong> and potential
              areas of concern across the industry.
            </span>
            <span>
              Companies can use the Global LCA to make informed decisions on
              their operations through
              <strong>understanding common environmental challenges</strong> at
              facilities. Facilities, both in development and in operation can
              compare and measure their impacts against this live industry
              average, gaining insight into their performance against the
              baseline.
            </span>
            <span>
              Benchmark Global LCAs are <strong>ISO-compliant</strong> and are
              <strong>‘cradle-to-gate’</strong>: the ‘cradle’ starts at raw
              material acquisition, and the ‘gate’ marks the finished product as
              defined by the goal and scope.
            </span>
            <span>
              Benchmark Global LCAs are
              <strong>featured in each Benchmark ESG Report</strong>
              that covers the battery supply chain, updated quarterly to ensure
              all market changes and developments in technologies or processes
              are captured accurately.
            </span>
          </div>
          <CommonButton class="mt-6" variant="secondary" link="/sustainability">
            More About ESG
          </CommonButton>
        </div>
        <div class="mx-auto mt-7 w-full md:w-3/5 lg:mt-0">
          <img
            class="mx-auto"
            src="https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,f_auto/v1677077661/assets/lca/Group_1825_nxftsk.png"
            alt="lca"
          />
        </div>
      </div>
    </div>
  </section>
</template>
